import React from "react";
import PropTypes from "prop-types";
import { useActionProxy } from "./useActionProxy.jsx";
import { DuplicateObjectDialog } from "../DuplicateObjectDialog/DuplicateObjectDialog.jsx";

export const DuplicateAction = React.forwardRef(
  ({ children, action, value, title, labelText, explainerText, submitButtonText, limit, ...rest }, ref) => {
    const [open, toggle, onSubmit, onCancel] = useActionProxy(children.props[action]);

    return (
      <>
        {React.cloneElement(children, { [action]: toggle, ref, ...rest })}
        <DuplicateObjectDialog
          name={value}
          title={title}
          labelText={labelText}
          explainerText={explainerText}
          submitButtonText={submitButtonText}
          open={open}
          onSubmit={onSubmit}
          onCancel={onCancel}
          limit={limit}
        />
      </>
    );
  }
);

DuplicateAction.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  action: PropTypes.string,
  title: PropTypes.string,
  labelText: PropTypes.string,
  explainerText: PropTypes.string,
  submitButtonText: PropTypes.string,
  limit: PropTypes.number,
};

DuplicateAction.defaultProps = {
  action: "onClick",
};

DuplicateAction.displayName = "DuplicateAction";
